import React from 'react';

function Electricity() {
  return (
    <div style={{ padding: '20px' }}>
      <h2>Electricity Services</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </div>
  );
}

export default Electricity;